// Bootstrap aplikasi: theme → cek sesi → login / shell.
import '@ui/theme.css';
import { initTheme } from '@core/theme';
import { renderLogin } from '@modules/auth/login.view';
import { adalahTautanPemulihan, renderPemulihan } from '@modules/auth/recovery.view';
import { currentSession } from '@modules/auth/auth.service';
import { isConfigured } from '@core/config';
import { loadSettings } from '@core/settings';
import { loadAkunKas } from '@core/akunkas.cache';
import { pantauPemeliharaan } from '@core/maintenance';
import { setSession } from '@core/session';
import { renderShell } from '@core/shell';
import { toast } from '@ui/toast';
import type { Session } from '@core/types';

async function start(): Promise<void> {
  initTheme();
  const app0 = document.querySelector<HTMLElement>('#app')!;
  // Datang dari tautan "lupa password" di email → WAJIB tetapkan password baru dulu. Kalau tidak,
  // aplikasi akan membuka dashboard memakai sesi pemulihan dan tautannya hangus tanpa dipakai.
  if (isConfigured() && adalahTautanPemulihan()) {
    renderPemulihan(app0, () => { window.location.replace(window.location.pathname); });
    return;
  }
  if (isConfigured()) {
    const s = await currentSession();
    if (s) {
      setSession(s);
      const [ok] = await Promise.all([loadSettings(), loadAkunKas()]);
      renderShell();
      pantauPemeliharaan();
      // Diam-diam memakai nilai pabrik itu berbahaya: biaya simpan, jatuh tempo, template WA,
      // nama & logo toko semuanya berubah tanpa ada yang sadar. Beri tahu, jangan tebak.
      if (!ok) toast('⚠️ Setelan toko gagal dimuat — sementara memakai nilai bawaan. Muat ulang halaman.');
      return;
    }
  }
  const app = document.querySelector<HTMLElement>('#app')!;
  renderLogin(app, (s: Session) => {
    setSession(s);
    void Promise.all([loadSettings(), loadAkunKas()]).then(([ok]) => {
      renderShell();
      pantauPemeliharaan();
      if (!ok) toast('⚠️ Setelan toko gagal dimuat — sementara memakai nilai bawaan. Muat ulang halaman.');
    });
  });
}

// Service worker: satu-satunya gunanya membuat aplikasi bisa dipasang ke layar depan HP
// (karyawan absen dari HP masing-masing tanpa membuka laptop). Ia sengaja tidak menyimpan cache —
// lihat public/sw.js. Kegagalan pendaftaran tak boleh mengganggu apa pun.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => { void navigator.serviceWorker.register('/sw.js').catch(() => undefined); });
}

void start();
